import React from 'react';
import PropTypes from 'prop-types'; 
import { Skeleton, Row, Col,Typography } from 'antd';
import styled from 'styled-components';

const { Title } = Typography;

const TitleWrapper = styled(Title)(
  () => `
    height: 48px;
    background: #f8f9fa;
`
);

const AddCarTypeSkeleton = ({ avatarSize = "large", inputWidth = 100, inputSize = "small", gutter = 16, padding = '28px 10px', backgroundColor = '#fff', align = 'center' }) => {
  return (
    <div style={{ textAlign: align, backgroundColor }}>
      <TitleWrapper level={3} />
      <Row gutter={gutter} justify="center" style={{padding}}>
        <Col>
          <Skeleton.Avatar active shape="circle" size={avatarSize} />
          <Skeleton.Input style={{ width: inputWidth, marginTop: 10, marginLeft: 10 }} active size={inputSize} />
        </Col>
        <Col>
          <Skeleton.Avatar active shape="circle" size={avatarSize} />
          <Skeleton.Input style={{ width: inputWidth, marginTop: 10, marginLeft: 10 }} active size={inputSize} />
        </Col>
        <Col>
          <Skeleton.Avatar active shape="circle" size={avatarSize} />
          <Skeleton.Input style={{ width: inputWidth, marginTop: 10, marginLeft: 10 }} active size={inputSize} />
        </Col>
      </Row>
    </div>
  );
};

AddCarTypeSkeleton.propTypes = {
  avatarSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  inputWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), 
  inputSize: PropTypes.string,
  gutter: PropTypes.number,
  padding: PropTypes.string,
  backgroundColor: PropTypes.string,
  align: PropTypes.string,
};

export default AddCarTypeSkeleton;
